export default "__VITE_ASSET__D2tds0AR__"